import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { SmartLink } from '../SmartLink';
import type { LinkCard } from '../../data/utilityPages';
type LinkCardGridProps = {
  headingId: string;
  heading: string;
  items: LinkCard[];
};
export function LinkCardGrid({
  headingId,
  heading,
  items
}: LinkCardGridProps) {
  const cols = items.length === 4 ? 'sm:grid-cols-2 lg:grid-cols-4' : 'sm:grid-cols-3';
  return <section aria-labelledby={headingId} data-id="element-1681" data-mp="109mak72wspg1">
      <h2 id={headingId} className="text-center text-[15px] font-semibold text-ink" data-id="element-1682" data-mp="106gj4l6t5bh5">
        {heading}
      </h2>
      <ul className={`mt-5 grid grid-cols-1 gap-3 ${cols}`} data-id="element-1683" data-mp="qadjpn3cbqxw">
        {items.map(item => {
        const Icon = item.icon;
        return <li key={item.title} data-id="element-1684" data-mp="v86ocbozwcw2">
              <SmartLink href={item.href} className="group flex h-full flex-col rounded-[14px] border border-canvas-line bg-white p-5 text-left transition-colors duration-150 ease-out hover:border-ink/25" data-id="element-1685" data-mp="vbkr3l1kmo41">
                <span className="flex h-9 w-9 items-center justify-center rounded-[9px] border border-canvas-line text-ink transition-colors duration-150 ease-out group-hover:text-brand" data-id="element-1686" data-mp="29acstek10r24">
                  <Icon className="h-[18px] w-[18px]" strokeWidth={1.75} aria-hidden="true" data-id="element-1687" data-mp="2j7ra1gdrxjvh" />
                </span>
                <span className="mt-4 flex items-center gap-1.5 text-[15px] font-semibold text-ink" data-id="element-1688" data-mp="2e7d2s0jzydyi">
                  {item.title}
                  <ArrowRightIcon className="h-4 w-4 text-brand transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-1689" data-mp="2s62xj9jcg1jp" />
                </span>
                <span className="mt-1 text-[14px] leading-[1.5] text-ink-muted" data-id="element-1690" data-mp="2wydwa92clhao">{item.copy}</span>
              </SmartLink>
            </li>;
      })}
      </ul>
    </section>;
}